const LABELS: Record<string, string> = {
  account_id: 'Conta', account_type: 'Tipo de conta', amount: 'Valor', balance: 'Saldo',
  confidence: 'Confiança', count: 'Quantidade', created_at: 'Criada em', credits: 'Créditos',
  credit_source: 'Origem dos créditos', date: 'Data', description: 'Descrição', document: 'Documento',
  due_date: 'Vencimento', name: 'Nome',
  covered_count: 'Itens cobertos', covered_amount: 'Valor coberto', exclusions: 'Exclusões', reasons: 'Motivos',
  documentation: 'Documentação compatível', reconciliation: 'Conciliação bancária',
  payment_evidence: 'Comprovação de pagamentos', effective_engine: 'Motor utilizado', evidence: 'Evidências',
  evidence_refs: 'Referências da evidência', subject_refs: 'Itens relacionados', facts: 'Fatos verificados',
  fiscal: 'Cobertura fiscal', rule_version: 'Versão da regra', engine: 'Motor', evaluated_at: 'Avaliada em',
  snapshot: 'Retrato da conta', checks: 'Verificações', results: 'Resultados', occurrences: 'Ocorrências',
  ai_findings: 'Achados sugeridos pela IA',
  all_time: 'Desde o início da medição', last_30_days: 'Últimos 30 dias', ai: 'Inteligência artificial',
  tokens: 'Tokens processados', sent: 'Envios concluídos',
  canonical: 'Fonte canônica', allocations_complete: 'Alocações completas', same_currency: 'Mesma moeda',
  reversals_known: 'Estornos conhecidos', closed: 'Movimento encerrado', movement_amount: 'Valor do movimento',
  allocated_amount: 'Valor alocado', rule_id: 'Regra',
  governance_ai: 'Análise de Governança com IA', scan_ai: 'Leitura de documento com IA', chat_ai: 'Chat com IA',
  contract_simple: 'Assinatura simples', contract_extended: 'Assinatura estendida',
  contract_icp_brasil: 'Assinatura externa com certificado digital',
  whatsapp: 'WhatsApp', sms: 'SMS', billing_email: 'E-mail de cobrança', storage_monthly: 'Armazenamento excedente mensal', id: 'Identificador', limitations: 'Limitações',
  measured_since: 'Medido desde', operation_id: 'Operação', operation_status: 'Estado da operação',
  priority: 'Prioridade', provider: 'Provedor', quantity: 'Quantidade',
  reference: 'Referência', requested_engine: 'Motor solicitado', rule_code: 'Regra', service: 'Serviço',
  source: 'Origem', status: 'Estado', summary: 'Resumo', title: 'Indício', type: 'Tipo',
  total_amount: 'Valor total', uncovered_amount: 'Sem cobertura identificada',
  unmeasured_count: 'Itens não medidos', updated_at: 'Atualizado em', user_name: 'Responsável',
  actor_name: 'Responsável', outcome: 'Desfecho da revisão', note: 'Observação',
  reused: 'Análise anterior reutilizada (sem nova cobrança)',
  score: 'Pontuação', weight: 'Peso', policy_version: 'Versão da política',
  document_number: 'Referência do documento', amounts: 'Valores das contas', payments: 'Pagamentos',
  payment_amounts: 'Valores das baixas', payment_amount: 'Valor bruto da baixa', ofx_amount: 'Valor do registro OFX',
  effective_paid: 'Principal liquidado', calculated_balance: 'Saldo calculado',
  movement_status: 'Estado do movimento', actual_direction: 'Sentido registrado', expected_direction: 'Sentido esperado',
  currency: 'Moeda', nature: 'Natureza do movimento', before: 'Antes da alteração', after: 'Depois da alteração',
  party: 'Parte relacionada', party_type: 'Tipo da parte', historical_accounts: 'Histórico comparável',
  median: 'Mediana do histórico', sample_count: 'Tamanho da amostra', reason: 'Motivo',
  historical_account_count: 'Contas no histórico registrado',
  receipt_status: 'Situação do comprovante', bank: 'Movimento bancário', bank_amount: 'Valor bancário',
  related_payment_count: 'Pagamentos distintos envolvidos', related_account_count: 'Contas distintas envolvidas',
  removed_attachment_count: 'Anexos retirados', related_instruction_count: 'Instruções distintas envolvidas',
  cashboxes_differ: 'Caixas registrados são diferentes', party_changed: 'Parte relacionada foi alterada',
  related_provider_count: 'Fornecedores distintos envolvidos', authorized_transaction_count: 'Autorizações distintas',
  party_documents_differ: 'Documentos da parte e da contraparte são diferentes', operator_is_beneficiary: 'Operador é a pessoa destinatária',
  party_model: 'Tipo de destinatário', associate_type: 'Pessoa associada ao operador',
  decoded_amount: 'Valor codificado no boleto', document_amount: 'Valor nominal lido', gross_amount: 'Valor bruto registrado',
  payment_method: 'Forma de pagamento', payment_date: 'Data do pagamento', reconciled: 'Conciliação registrada',
  amount_cents: 'Valor da instrução (centavos)', settled_amount_cents: 'Valor informado pelo provedor (centavos)',
  settled_at: 'Data informada da liquidação', applied_at: 'Aplicação interna registrada em', paid: 'Comprovante indica efetivação',
  exclusion: 'Motivo da exclusão',
  settlement_amount: 'Valor da baixa', principal: 'Principal', components: 'Componentes financeiros',
  interest: 'Juros', penalty: 'Multa', charges: 'Encargos', discount_granted: 'Desconto concedido',
  discount_obtained: 'Desconto obtido', fed_retention: 'Retenções federais', iss_retention: 'Retenção de ISS',
  invoice_net: 'Valor líquido da nota', received_principal: 'Principal recebido', difference: 'Diferença',
  invoice_ids: 'Notas fiscais', account_ids: 'Contas vinculadas',
};

const VALUES: Record<string, string> = {
  ai: 'IA', analyzed: 'Analisada', bonus: 'Bônus', card: 'Cartão', completed: 'Concluída',
  consumption: 'Consumo', economic: 'Econômico', failed: 'Falhou', high_provenance: 'Alta',
  internal_transfer: 'Transferência interna', low_provenance: 'Baixa', mixed: 'Bônus e recarga',
  new: 'Nova', ofx: 'OFX', open_finance: 'Open Finance', payable: 'Conta a pagar', paid: 'Paga',
  plan: 'Franquia do plano', pending: 'Aguardando confirmação', pix: 'PIX', receivable: 'Conta a receber', recharge: 'Recarga',
  reversed: 'Estornada', seen: 'Vista', traditional: 'Tradicional', uncertain: 'Confirmação pendente',
  issuing: 'Gerando cobrança', submitting: 'Enviando ao gateway', cancelled: 'Cancelada',
  suspended: 'Suspensa', active: 'Ativa', disabled: 'Desativada',
  automatic_pix: 'Pix Automático', authorization_pending: 'Aguardando autorização',
  authorization_failed: 'Autorização não concluída', cancel_pending: 'Cancelamento em confirmação',
  reserved: 'Reservada', released: 'Liberada', system: 'Sistema', unknown: 'Não identificado',
  document: 'documento', analysis: 'análise', message: 'mensagem', unit: 'unidade',
  high: 'Alta', medium: 'Média', low: 'Baixa', critical: 'Crítica',
  queued: 'Na fila', running: 'Em andamento', legitimate: 'Legítimo após revisão',
  corrected: 'Corrigido', inconclusive: 'Inconclusivo', confirmed: 'Suspeita confirmada pela revisão',
  divergence: 'Divergência', review: 'Revisão', not_evaluated: 'Não avaliada', technical_error: 'Erro técnico',
  satisfied: 'Sem divergência', money: 'Dinheiro',
  inflow: 'Entrada', outflow: 'Saída', posted: 'Confirmado', ignored: 'Ignorado',
  operational: 'Operacional', internal: 'Interna', normal: 'Normal',
  provider: 'Fornecedor', client: 'Cliente', employee: 'Funcionário', intern: 'Estagiário', partner: 'Sócio', cashbox: 'Caixa',
  scheduled: 'Agendado', settled: 'Liquidado', applied: 'Aplicado', authorized: 'Autorizado',
  bank_slip: 'Boleto', transfer: 'Transferência bancária', check: 'Cheque', debit_account: 'Débito em conta',
  credit: 'Cartão de crédito', debit: 'Cartão de débito', none: 'Não especificado',
  scan_ai: 'Leitura de documento com IA', governance_ai: 'Análise de Governança com IA', chat_ai: 'Chat com IA',
  contract_simple: 'Assinatura simples', contract_extended: 'Assinatura estendida',
  contract_icp_brasil: 'Assinatura externa com certificado digital',
  manual_adjustment: 'Ajuste manual',
};

const MONEY_KEYS = new Set([
  'amount', 'total_amount', 'undetermined_amount', 'uncovered_amount', 'determined_base',
  'recharge_remaining', 'bonus_remaining', 'covered_amount',
  'movement_amount', 'allocated_amount', 'bank_amount', 'settlement_amount', 'principal',
  'payment_amount', 'payment_amounts', 'ofx_amount', 'effective_paid', 'calculated_balance', 'amounts', 'median',
  'discount_granted', 'discount_obtained', 'interest', 'penalty', 'charges', 'fed_retention', 'iss_retention',
  'decoded_amount', 'document_amount', 'gross_amount', 'invoice_net', 'received_principal', 'difference',
]);

export function governanceFieldLabel(key: string): string {
  if (key.includes('.')) return key.split('.').map(part => /^\d+$/.test(part)
    ? `Item ${Number(part) + 1}` : governanceFieldLabel(part)).join(' · ');
  return LABELS[key] ?? key.replace(/_/g, ' ').replace(/^./, letter => letter.toUpperCase());
}

export function governanceValueLabel(value: string): string {
  const model = value.match(/^App\\Models\\(?:[^\\]+\\)*(Provider|Client|Employee|Intern|Partner|Cashbox)$/);
  if (model) return VALUES[model[1].toLowerCase()] ?? model[1];
  return VALUES[value] ?? value.replace(/_/g, ' ').replace(/^./, letter => letter.toUpperCase());
}

export function formatCredits(value: number | string | null | undefined): string {
  if (value == null || value === '') return 'Não informado';
  const parsed = Number(value);
  return Number.isFinite(parsed) ? `${parsed.toLocaleString('pt-BR')} créditos` : String(value);
}

export function formatMoney(value: number | string | null | undefined): string {
  if (value == null || value === '') return 'Não informado';
  const parsed = Number(value);
  return Number.isFinite(parsed)
    ? parsed.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace(/\u00a0/g, ' ')
    : String(value);
}

export function formatGovernanceValue(value: unknown, key = ''): string {
  key = key.split('.').pop() ?? key;
  if (value == null || value === '') return 'Não informado';
  if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
  if (typeof value === 'number') {
    if (key === 'credits') return formatCredits(value);
    return MONEY_KEYS.has(key) ? formatMoney(value) : value.toLocaleString('pt-BR');
  }
  if (typeof value === 'string') {
    if (key === 'credits' && /^-?\d+(\.\d+)?$/.test(value)) return formatCredits(value);
    if (MONEY_KEYS.has(key) && /^-?\d+(\.\d+)?$/.test(value)) return formatMoney(value);
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [year, month, day] = value.split('-');
      return `${day}/${month}/${year}`;
    }
    if (/^\d{4}-\d{2}-\d{2}(T|\s)/.test(value)) {
      const date = new Date(value);
      if (!Number.isNaN(date.getTime())) return date.toLocaleString('pt-BR');
    }
    return governanceValueLabel(value);
  }
  if (Array.isArray(value)) return value.length ? value.map(item => formatGovernanceValue(item, key)).join(' · ') : 'Nenhum';
  if (typeof value === 'object') {
    return Object.entries(value as Record<string, unknown>)
      .filter(([childKey]) => !isInternalGovernanceKey(childKey))
      .map(([childKey, child]) => /^[0-9a-f]{8}-[0-9a-f-]{27}$/i.test(childKey)
        ? formatGovernanceValue(child, key)
        : `${governanceFieldLabel(childKey)}: ${formatGovernanceValue(child, childKey)}`)
      .join(' · ');
  }
  return String(value);
}

export function isInternalGovernanceKey(key: string): boolean {
  const normalized = key.toLowerCase();
  return normalized.includes('fingerprint') || normalized === 'revision' || normalized === 'independent_event_key'
    || normalized === 'id' || normalized.endsWith('.id') || normalized.endsWith('_id') || normalized.endsWith('_ids')
    || normalized.endsWith('_hash') || normalized.endsWith('_hashes') || normalized.endsWith('_refs')
    || normalized === 'assigned_to';
}
